export default [
    {
        path: '/commissions',
        name: 'commissions',
        component: () =>
            import(
                /* webpackChunkName: "commissions" */ '@/views/commissions/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Comissões',
                    to: { name: 'commissions' },
                    disable: true,
                },
            ],
            reseller: true,
        },
    },
    {
        path: '/commissions/show/:id',
        name: 'commissions/show',
        component: () =>
            import(
                /* webpackChunkName: "commissions" */ '@/views/commissions/Show.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Comissões',
                    to: { name: 'commissions' },
                    disable: false,
                },
                {
                    text: 'Exibir',
                    to: { name: 'commissions/show' },
                    disable: true,
                },
            ],
            reseller: true,
        },
        props: true,
    },
]
